import { render, staticRenderFns } from "./CreateAddressPage.vue?vue&type=template&id=605e9486&scoped=true"
import script from "./CreateAddressPage.vue?vue&type=script&lang=js"
export * from "./CreateAddressPage.vue?vue&type=script&lang=js"
import style0 from "./CreateAddressPage.vue?vue&type=style&index=0&id=605e9486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605e9486",
  null
  
)

export default component.exports